var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FlexBox } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import * as React from 'react';
import Dropzone from 'react-dropzone';
const MAX_FILE_SIZE = 20097152; //20097152 ~20mb.
const ALLOWED_FILE_TYPES = 'audio/*';
class Upload extends React.Component {
    constructor(props) {
        super(props);
        this.dropzone = React.createRef();
        this.filename = React.createRef();
        this.state = {
            dropzoneText: 'Drop files here or click to upload.',
            file: null,
            filename: '',
            filenameErrorLabel: '',
            filenameFormGroup: '',
            readyToUpload: false,
            uploadBtndDisabled: '',
        };
    }
    componentWillUnmount() {
        this.setState({
            dropzoneText: 'Drop files here or click to upload.',
            file: null,
            filename: '',
            filenameErrorLabel: '',
            filenameFormGroup: '',
            readyToUpload: false,
            uploadBtndDisabled: '',
        });
    }
    bytesToSize(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) {
            return '0 Byte';
        }
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`;
    }
    onDrop(acceptedFiles, rejectedFiles) {
        if (acceptedFiles.length > 0) {
            if (this.state.filename.trim().length === 0) {
                this.setState({ filename: acceptedFiles[0].name });
            }
            this.setState({
                filenameErrorLabel: '',
                filenameFormGroup: '',
                dropzoneText: `${acceptedFiles[0].name} ${this.bytesToSize(acceptedFiles[0].size)} dropped!`,
                file: acceptedFiles[0],
                uploadBtndDisabled: 'btn-success',
                readyToUpload: true,
            }, () => {
                this.onClickUpload();
            });
        }
        else if (rejectedFiles.length > 0) {
            if (MAX_FILE_SIZE <= rejectedFiles[0].size) {
                this.setState({
                    dropzoneText: `Maximum upload file size is ${this.bytesToSize(MAX_FILE_SIZE)}. File size on "${rejectedFiles[0].name}" is ${this.bytesToSize(rejectedFiles[0].size)}!`,
                    file: null,
                    readyToUpload: false,
                });
            }
            else {
                this.setState({
                    dropzoneText: `Only audio files are supported`,
                    file: null,
                    readyToUpload: false,
                });
            }
        }
    }
    onClickUpload() {
        if (this.state.file && this.state.filename.trim().length) {
            this.setState({
                uploadBtndDisabled: 'disabled',
                dropzoneText: 'Uploading...',
            });
            this.props
                .waitMusicUpload({
                file: this.state.file,
                filename: this.state.filename,
            })
                .then((response) => {
                this.setState({
                    dropzoneText: 'Spliting...',
                    uploadBtndDisabled: 'disabled',
                });
                this.props
                    .waitMusicSplit({
                    masterFilePath: response.data.relative_uri,
                    name: this.state.filename,
                })
                    .then(() => {
                    this.setState({
                        dropzoneText: 'Upload complete',
                        uploadBtndDisabled: '',
                    });
                    this.props.waitMusicWaitingForSplitingOpen();
                })
                    .catch((err) => {
                    console.error('waitMusicSplit Exception', err);
                    this.setState({
                        uploadBtndDisabled: '',
                        dropzoneText: 'An error occurred...',
                    });
                });
            })
                .catch((err) => {
                console.error('Exception', err);
            });
        }
        else {
            this.setState({
                filenameErrorLabel: 'Please add a filename',
                filenameFormGroup: 'has-error',
            });
            if (this.filename.current) {
                this.filename.current.focus();
            }
        }
    }
    onOpenDropzoneClick() {
        if (this.dropzone && this.dropzone.current) {
            this.dropzone.current.open();
        }
    }
    changeFilename(event) {
        this.setState({ filename: event.target.value });
    }
    render() {
        let status = 'Select a file to upload';
        if (this.props.meta.uploadAsyncStatus === 'succeeded') {
            if (this.state.readyToUpload === true) {
                status = 'Upload file';
            }
        }
        else if (this.props.meta.uploadAsyncStatus === 'loading') {
            status = 'Please wait..';
        }
        if (this.state.dropzoneText === 'Uploading...') {
            status = this.state.dropzoneText;
        }
        return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsxs("div", Object.assign({ className: 'form-group ' + this.state.filenameFormGroup }, { children: [_jsx("label", Object.assign({ className: "control-label", htmlFor: "filename" }, { children: "Title" })), _jsx("input", { id: "filename", ref: this.filename, onChange: this.changeFilename, value: this.state.filename, className: "form-control", type: "text", placeholder: "eg. My custom music..." })] })), _jsx(Dropzone, Object.assign({ ref: this.dropzone, onDrop: this.onDrop, accept: ALLOWED_FILE_TYPES, multiple: false, className: "dropzone", maxSize: MAX_FILE_SIZE }, { children: _jsx("div", { children: _jsx("p", { children: this.state.dropzoneText }) }) })), _jsx(Button, Object.assign({ type: "button", disabled: this.state.uploadBtndDisabled === 'disabled', id: "upload", onClick: this.state.readyToUpload
                        ? this.onClickUpload
                        : this.onOpenDropzoneClick }, { children: status }))] })));
    }
}
__decorate([
    boundMethod
], Upload.prototype, "bytesToSize", null);
__decorate([
    boundMethod
], Upload.prototype, "onDrop", null);
__decorate([
    boundMethod
], Upload.prototype, "onClickUpload", null);
__decorate([
    boundMethod
], Upload.prototype, "onOpenDropzoneClick", null);
__decorate([
    boundMethod
], Upload.prototype, "changeFilename", null);
export default Upload;
